import { isNil } from 'lodash';
import React, { useEffect, type FunctionComponent, useRef, useState } from 'react';
import { Menu as SGMenu } from '../../menu/index';
import { ContextMenu, Item } from '../types';

interface IMenuProps {
  contextMenu: ContextMenu;
  item: Item;
  closePopover: () => void;
}

const scrollDistance = 100;

export const Menu: FunctionComponent<IMenuProps> = ({ item, contextMenu, closePopover }) => {
  const [initialHeight, setInitialHeight] = useState<number | null>(null);
  const myRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const rect = myRef.current?.getBoundingClientRect();

    if (!initialHeight) {
      setInitialHeight(rect?.top ?? 0);
    } else if (Math.abs(initialHeight - (rect?.top ?? 0)) > scrollDistance) {
      closePopover();
    }
  });

  return (
    <SGMenu ref={myRef} subject={'json-formatter-menu'}>
      {!isNil(contextMenu.menuName) && <SGMenu.Title>{contextMenu?.menuName}</SGMenu.Title>}
      {contextMenu.menuItems.map((menu, i) => {
        return (
          <SGMenu.Item
            key={i}
            icon={menu.icon}
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              e.stopPropagation();
              menu.onClick(item);
              closePopover();
            }}
          >
            {menu.label}
          </SGMenu.Item>
        );
      })}
    </SGMenu>
  );
};
